export default "__VITE_ASSET__b2970519__"